import type { SxProps, Theme } from '@mui/material';

import { IllustrationWrapper } from '../IllustrationWrapper';

import { SaveToBookmarksIllustration } from './SaveToBookmarks';

interface Props {
  readonly sx?: SxProps<Theme>;
  readonly title?: string;
}

export const SaveToBookmarks = ({ sx, title }: Readonly<Props>) => (
  <IllustrationWrapper sx={sx}>
    <SaveToBookmarksIllustration title={title} />
  </IllustrationWrapper>
);
